import { render, staticRenderFns } from "./cardItemByTeacher.vue?vue&type=template&id=fdf72f8e&"
import script from "./cardItemByTeacher.vue?vue&type=script&lang=js&"
export * from "./cardItemByTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/card/cardItemByTeacher.vue"
export default component.exports